<script>
export default {
  name: 'DialogBaseTitle'
}
</script>
<template>
  <v-card-title class="text-h5 justify-center wordBreak">
    <h2 class="headline primary--text text--primary-2">
      <slot></slot>
    </h2>
  </v-card-title>
</template>
